import Icon from '../components/Icon.vue'

Icon.register({
  'meh-blank': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM168 240c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zM328 240c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/meh-blank.js
// module id = 1558
// module chunks = 0